import { yupResolver } from "@hookform/resolvers/yup";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import { generateYupSchemaTableField } from "constants/FormatDataContanst";
import {
  KHMCTU_DEFAULT,
  TAX_DEDUCT_COMMON_FIELD,
  TAX_DEDUCT_CONTENT_FIELD,
  TAX_DEDUCT_DSCTSSDUNG_FIELD,
  TAX_DEDUCT_DSDKUNHIEM_FIELD,
} from "constants/TaxDeductRegisterConstant";
import { english } from "flatpickr/dist/l10n/default";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import "flatpickr/dist/themes/material_blue.css";
import { loopGenerateField } from "helpers/form_helper_license";
import { generateTableV2 } from "helpers/form_helper_old";
import {
  formatTimestampToDate,
  MODE_FORM,
} from "pages/DataFormatInvoice/utils";
import { convertDate, customViewField } from "pages/IssueInvoice/utils";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import {
  createTaxDeductsRegistry,
  editTaxDeductsRegistry,
  getDetailTaxDeductsRegistry,
} from "store/actions";
import * as yup from "yup";
import { initOptionDateLocale } from "./utils";

const CQTQLY_JSON = require("pages/DataFormatInvoice/Registry-invoice/CQTQLY.json");

const DetailData = props => {
  const { isOpen, toggle, dataDetail, t, i18n, toggleReleaseModal } = props;
  const [optionDateLocale, setOptionDateLocale] =
    useState(initOptionDateLocale);

  const { listSignInfo, loadListMethodSign } = useSelector(
    state => state.Dashboard
  );

  const dataFormat = useSelector(state => state.dataFormat);
  const {
    loading: loadingDetail,
    data: detailTaxDeductsRegistry,
    error,
  } = dataFormat.detailTaxDeductsRegistryData;

  const {
    loading: loadingCreate,
    data: createData,
    error: errorCreateData,
  } = dataFormat.createTaxDeductsRegistryData;

  const {
    loading: loadingEdit,
    data: editData,
    error: errorEditData,
  } = dataFormat.editTaxDeductsRegistryData;

  const Dashboard = useSelector(state => state.Dashboard);
  const { finalBuReleaseInfo, buStoreHeader, finalBuInfo } = Dashboard;

  const setDefaultConfigField = () => {
    const defaultBusinessUnitInfoField = {
      // [TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_TEN.field]: "ten",
      // [TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_MST.field]: "mst",
      // [TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_DCHI.field]: "dchi",
      // [TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_DCTDTU.field]: "dctdtu",
      // [TAX_DEDUCT_TCTTNHAP_FIELD.TCTTNHAP_SDTHOAI.field]: "sdthoai",
    };
    if (finalBuReleaseInfo) {
      for (const key in defaultBusinessUnitInfoField) {
        const defaultValue =
          finalBuReleaseInfo[defaultBusinessUnitInfoField[key]];
        if (defaultValue) {
          setValue(key, defaultValue);
        } else {
          setValue(key, "");
        }
      }
    }
    // if (!configField.loadingConfigField) {
    //   setTimeout(() => {
    //     if (modal && modal.current) {
    //       modal.current.scrollTop = 0;
    //     }
    //   });
    // }
  };

  const modal = useRef(null);
  const [disableForm, setDisableForm] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { previewPdfRegisterFile, type, fileDownload, fileDownloadName } =
    dataFormat;
  const { addToast } = useToasts();
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };
  useEffect(() => {
    if (
      previewPdfRegisterFile &&
      previewPdfRegisterFile.data &&
      previewPdfRegisterFile.typePreview !== "popupType"
    ) {
      const link = document.createElement("a");
      link.href = previewPdfRegisterFile.data;
      link.setAttribute("download", "Invoice.pdf");
      document.body.appendChild(link);
      link.click();
      addToast("Tải xuống thành công", {
        appearance: "success",
        autoDismiss: true,
      });
    } else {
      if (previewPdfRegisterFile && previewPdfRegisterFile.error) {
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
      }
    }
  }, [previewPdfRegisterFile]);

  // Language Change
  useEffect(() => {
    const lang = i18n.language;
    switch (lang) {
      case "vn":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...Vietnamese,
            firstDayOfWeek: optionDateLocale.locale.firstDayOfWeek,
          },
        });
        break;
      case "en":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...english,
            firstDayOfWeek: optionDateLocale.locale.firstDayOfWeek,
          },
        });
        break;
      default:
        break;
    }
  }, [t]);

  const dispatch = useDispatch();

  const FIRST_BLOCK = [
    TAX_DEDUCT_COMMON_FIELD.TEN,
    TAX_DEDUCT_COMMON_FIELD.MSO,

    TAX_DEDUCT_COMMON_FIELD.HTHUC,
    TAX_DEDUCT_COMMON_FIELD.TNNT,
    TAX_DEDUCT_COMMON_FIELD.CQTQLY,
    TAX_DEDUCT_COMMON_FIELD.MCQTQLY,
    TAX_DEDUCT_COMMON_FIELD.MST,

    TAX_DEDUCT_COMMON_FIELD.NLHE,
    TAX_DEDUCT_COMMON_FIELD.DCLHE,
    TAX_DEDUCT_COMMON_FIELD.DCTDTU,
    TAX_DEDUCT_COMMON_FIELD.DTLHE,
    TAX_DEDUCT_COMMON_FIELD.DDANH,
    TAX_DEDUCT_COMMON_FIELD.NLAP,
  ];

  const SECOND_BLOCK = [
    TAX_DEDUCT_CONTENT_FIELD.DTPHANH.TCCNPHANH,
    TAX_DEDUCT_CONTENT_FIELD.DTPHANH.CQTPHanh,
  ];

  const THIRD_BLOCK = [
    TAX_DEDUCT_CONTENT_FIELD.LHSDUNG.CTTNCNHAN,
    TAX_DEDUCT_CONTENT_FIELD.LHSDUNG.CTKTTTMDTU,
    TAX_DEDUCT_CONTENT_FIELD.LHSDUNG.BLTPLPKIN,
    TAX_DEDUCT_CONTENT_FIELD.LHSDUNG.BLTPLPIN,
    TAX_DEDUCT_CONTENT_FIELD.LHSDUNG.BLTTPLPHI,
  ];

  const FOURTH_BLOCK = [
    TAX_DEDUCT_CONTENT_FIELD.HTGDLCTDT.CDLQCCQT,
    TAX_DEDUCT_CONTENT_FIELD.HTGDLCTDT.CDLQTCTN,
    TAX_DEDUCT_CONTENT_FIELD.HTGDLCTDT.CDLQTCTNUT,
  ];

  const objSchema = {};
  const initDefaultValues = {};
  const TOTAL_FIELD = [
    ...FIRST_BLOCK,
    ...SECOND_BLOCK,
    ...THIRD_BLOCK,
    ...FOURTH_BLOCK,
  ];

  TOTAL_FIELD.map(item => {
    const itemField = item;
    switch (itemField.type) {
      case "text":
        initDefaultValues[itemField.field] = itemField.defaultValue || "";

        objSchema[itemField.field] = yup.string();
        if (itemField.required) {
          objSchema[itemField.field] = objSchema[itemField.field].required(
            t("form.validate.required", { title: t(`form.${itemField.field}`) })
          );
        }
        if (itemField.max) {
          objSchema[itemField.field] = objSchema[itemField.field].max(
            itemField.max,
            t("form.validate.char_max", { max: itemField.max })
          );
        }
        if (itemField.isCMND) {
          objSchema[itemField.field] = objSchema[itemField.field].test(
            "len",
            "Vui lòng nhập 8 || 9 || 12 ký tự",
            val =>
              val.length === 0 ||
              val.length === 8 ||
              val.length === 9 ||
              val.length === 12
          );
        }
        if (itemField.isEmail) {
          objSchema[itemField.field] = objSchema[itemField.field].email(
            t("form.validate.invalid", { title: t(`form.${itemField.field}`) })
          );
        }
        if (itemField.isTaxCode) {
          objSchema[itemField.field] = objSchema[itemField.field].test(
            "len",
            "Vui lòng nhập 10 hoặc 14 ký tự",
            val => val.length === 0 || val.length === 10 || val.length === 14
          );
        }
        if (itemField.isKHHD) {
          //   objSchema[itemField.field] = objSchema[itemField.field].matches(
          //     /^[A]*$/,
          //     "Vui lòng chỉ nhập các ký tự (A, B, C, D, E, G, H, K, L, M, N, P, Q, R, S, T, U, V, X, Y)"
          //   );
          // objSchema[itemField.field] = objSchema[itemField.field].test(
          //   "len",
          //   "Vui lòng nhập 2 ký tự cuối (A, B, C, D, E, G, H, K, L, M, N, P, Q, R, S, T, U, V, X, Y)",
          //   val => {
          //     return val.length === 6;
          //   }
          // );
          initDefaultValues[itemField.field] = undefined;

          objSchema[itemField.field] = objSchema[itemField.field];
          objSchema[itemField.field] = yup.object();
          if (itemField.required) {
            objSchema[itemField.field] = objSchema[itemField.field].required(
              t("form.validate.select", { title: t(`form.${itemField.field}`) })
            );
          }
        }
        //
        break;
      case "number":
        initDefaultValues[itemField.field] = 0;

        objSchema[itemField.field] = yup.number();
        if (itemField.required) {
          objSchema[itemField.field] = objSchema[itemField.field].required(
            t("form.validate.required", { title: t(`form.${itemField.field}`) })
          );
        }

        // objSchema[itemField.field] = objSchema[itemField.field].matches(
        //   /^[0-9]+$/,
        //   t("form.validate.integer")
        // );

        if (itemField.max) {
          objSchema[itemField.field] = objSchema[itemField.field].max(
            itemField.max,
            t("form.validate.integer_max", { max: itemField.max })
          );
        }
        break;
      case "select":
        initDefaultValues[itemField.field] =
          itemField.defaultValue || undefined;
        objSchema[itemField.field] = yup.object().nullable();
        if (itemField.required) {
          objSchema[itemField.field] = objSchema[itemField.field].required(
            t("form.validate.select", { title: t(`form.${itemField.field}`) })
          );
        }
        break;
      case "date":
        initDefaultValues[itemField.field] = itemField.defaultValue || [];
        objSchema[itemField.field] = yup.array();
        if (itemField.required) {
          objSchema[itemField.field] = objSchema[itemField.field].min(
            1,
            t("form.validate.select", { title: t(`form.${itemField.field}`) })
          );
        }
        break;
      case "object":
        objSchema[itemField.field] = yup.mixed().nullable();
        break;
      case "radioField":
        initDefaultValues[itemField.field] = itemField.defaultValue || 0;
        break;
      default:
        break;
    }
  });

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        addNewLineDSCTSSDUNG();
        // setDefaultConfigField();
      });
      checkDisableForm();
      reset();
      if (dataDetail?.id) {
        dispatch(getDetailTaxDeductsRegistry(dataDetail.id));
      } else {
      }
      setTimeout(() => {
        if (modal && modal.current) {
          modal.current.scrollTop = 0;
          //   setFocus(COMMON_FIELD.TNNT.field);
        }
      });
    }
  }, [isOpen]);

  const checkDisableForm = () => {
    if (dataDetail?.mode === MODE_FORM.VIEW) {
      setDisableForm(true);
    } else {
      setDisableForm(false);
    }
  };

  // Custom set default value
  const setDefaultValue = (FIELDS, isTimeOut = false) => {
    for (const key in FIELDS) {
      const finalKey = FIELDS[key].field;
      const type = FIELDS[key].type;
      let finalValue = detailTaxDeductsRegistry[finalKey];
      if (finalValue) {
        switch (type) {
          case "radioField":
            setValue(finalKey, finalValue);
            break;
          case "select":
            const option = OPTION_GROUP[finalKey];
            const valueSelect = option.find(
              item => Number(item.value) === Number(finalValue)
            );
            if (valueSelect) {
              setValue(finalKey, valueSelect);
            } else if (finalValue) {
              setValue(finalKey, {
                value: finalValue,
                label: finalValue,
              });
            }
            break;
          case "text":
            switch (finalKey) {
              // case TAX_DEDUCT_COMMON_FIELD.TTCHUNG_KHCTU.field:
              //   finalValue =
              //     detailTaxDeductsRegistry[
              //       TAX_DEDUCT_COMMON_FIELD.TTCHUNG_MSCTU.field
              //     ] +
              //     " " +
              //     detailTaxDeductsRegistry[finalKey];

              //   break;
              // case TAX_DEDUCT_COMMON_FIELD.TTCHUNG_SCTU.field:
              //   finalValue =
              //     Number(finalValue) === 0 || finalValue === null
              //       ? "Chờ cấp số"
              //       : finalValue;
              //   break;
              default:
                break;
            }
            setValue(finalKey, finalValue);
            break;
          case "date":
            const date = formatTimestampToDate(finalValue);
            setValue(finalKey, [date]);
            break;
          case "field_array":
            setValue(
              finalKey,
              finalValue.map(item => {
                return {
                  tlblai: item.tlblai,
                  khmblai: item.khmblai,
                  khblai: item.khblai,
                  sluong: item.sluong,
                  tso: item.tso,
                  dso: item.dso,
                  nbdsdung: item.nbdsdung ? [new Date(item.nbdsdung)] : [],
                  hdong: item.hdong,
                  ttcgp: item.ttcgp,
                  msttcgp: item.msttcgp,
                };
              })
            );
            break;
        }
      }
    }
  };

  const schemaListDSCTSSDUNG = generateYupSchemaTableField({
    fieldConstant: TAX_DEDUCT_DSCTSSDUNG_FIELD.DSCTSSDUNG_LIST.field,
    listConstant: TAX_DEDUCT_DSCTSSDUNG_FIELD.DSCTSSDUNG_LIST,
    t,
    yup,
  });

  const schemaListDSDKUNHIEM = generateYupSchemaTableField({
    fieldConstant: TAX_DEDUCT_DSDKUNHIEM_FIELD.DSDKUNHIEM_LIST.field,
    listConstant: TAX_DEDUCT_DSDKUNHIEM_FIELD.DSDKUNHIEM_LIST,
    t,
    yup,
  });

  const finalSchema = useMemo(() => {
    return yup.object().shape({
      ...objSchema,
      [TAX_DEDUCT_DSCTSSDUNG_FIELD.DSCTSSDUNG_LIST.field]: yup
        .array()
        .of(schemaListDSCTSSDUNG),
      [TAX_DEDUCT_DSDKUNHIEM_FIELD.DSDKUNHIEM_LIST.field]: yup
        .array()
        .of(schemaListDSDKUNHIEM),
    });
  }, [objSchema, schemaListDSCTSSDUNG, schemaListDSDKUNHIEM]);

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
    setFocus,
  } = useForm({
    resolver: yupResolver(finalSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ...initDefaultValues,

      [TAX_DEDUCT_COMMON_FIELD.NLAP.field]: [new Date()],
      [TAX_DEDUCT_DSCTSSDUNG_FIELD.DSCTSSDUNG_LIST.field]: [],
      [TAX_DEDUCT_DSDKUNHIEM_FIELD.DSDKUNHIEM_LIST.field]: [],
    },
  });

  const OPTION_HTHUC = [
    {
      value: TAX_DEDUCT_COMMON_FIELD.HTHUC.selectValues.ADD,
      label: "Đăng ký mới",
    },
    {
      value: TAX_DEDUCT_COMMON_FIELD.HTHUC.selectValues.EDIT,
      label: "Thay đổi thông tin",
    },
  ];

  const OPTION_CA_HTHUC = [
    {
      value: TAX_DEDUCT_DSCTSSDUNG_FIELD.DSCTSSDUNG_LIST.HTHUC.selectValues.ADD,
      label: "Thêm mới",
    },
    {
      value:
        TAX_DEDUCT_DSCTSSDUNG_FIELD.DSCTSSDUNG_LIST.HTHUC.selectValues.EXTEND,
      label: "Gia hạn",
    },
    {
      value:
        TAX_DEDUCT_DSCTSSDUNG_FIELD.DSCTSSDUNG_LIST.HTHUC.selectValues.STOP_USE,
      label: "Ngừng sử dụng",
    },
  ];

  const OPTION_CQTQLY = Object.entries(CQTQLY_JSON).map(([key, value]) => {
    return {
      value: value,
      label: key + " - " + value,
      code: key,
    };
  });

  const OPTION_GROUP = {
    [TAX_DEDUCT_COMMON_FIELD.HTHUC.field]: OPTION_HTHUC,
    [TAX_DEDUCT_COMMON_FIELD.CQTQLY.field]: OPTION_CQTQLY,
  };

  useEffect(() => {
    console.log(
      "🚀 ~ file: DetailData.js ~ line 121 ~ useEffect ~ errors",
      errors
    );
  }, [errors]);

  const submitForm = values => {
    console.log("🚀 submitForm ~ values", values);
    const finalData = formatData(values);
    console.log("🚀 submitForm ~ finalData", finalData);
    if (dataDetail.id) {
      dispatch(editTaxDeductsRegistry(finalData, dataDetail.id));
    } else {
      dispatch(createTaxDeductsRegistry(finalData));
    }
  };

  const formatListData = data => {
    const listData = [];
    let stt = 0;
    for (const item of data) {
      const childData = {};
      stt = stt + 1;
      for (const keyItem in item) {
        const dataChild = item[keyItem];
        if (!dataChild) {
          continue;
        }
        childData["stt"] = stt;
        // get From Date
        if (Array.isArray(dataChild)) {
          const tngay = convertDate(dataChild[0]);
          const dngay = convertDate(dataChild[1]);
          childData["tngay"] = tngay;
          childData["dngay"] = dngay || null;
        } else if (typeof dataChild === "object" && dataChild !== null) {
          // get value from select
          childData[keyItem] = dataChild.value;
        } else {
          // get value text
          childData[keyItem] = dataChild;
        }
      }
      console.log("🚀 ~ childData:", childData);
      listData.push(childData);
    }
    return listData;
  };

  const formatData = values => {
    const finalData = {};

    TOTAL_FIELD.map(item => {
      const itemField = item;
      const valueField = values[itemField.field];
      switch (itemField.type) {
        case "object":
          finalData[itemField.field] = valueField;
          break;
        case "text":
          finalData[itemField.field] = valueField || "";
          break;
        case "number":
          finalData[itemField.field] = Number(valueField);
          break;
        case "select":
          finalData[itemField.field] = valueField?.value
            ? valueField.value
            : "";
          break;
        case "date":
          finalData[itemField.field] = convertDate(valueField[0], "YYYY-MM-DD");
          break;
        case "radioField":
          finalData[itemField.field] = Number(valueField) || 0;
          break;

        default:
          break;
      }
    });

    finalData[TAX_DEDUCT_DSCTSSDUNG_FIELD.DSCTSSDUNG_LIST.field] =
      formatListData(values[TAX_DEDUCT_DSCTSSDUNG_FIELD.DSCTSSDUNG_LIST.field]);

    finalData[TAX_DEDUCT_DSDKUNHIEM_FIELD.DSDKUNHIEM_LIST.field] =
      formatListData(values[TAX_DEDUCT_DSDKUNHIEM_FIELD.DSDKUNHIEM_LIST.field]);

    return finalData;
  };

  const generalField = value => {
    let placeholder = "";
    if (value.isTaxCode) {
      placeholder = "XXXXXXXXXX-XXX (10 hoặc 14 kí tự)";
    } else {
      placeholder = t("placeholder.enter", {
        title: t(`form.${value.field}`),
      });
    }
    return loopGenerateField({
      item: value,
      label: t(`form.${value.field}`),
      placeholder,
      errors,
      touchedFields,
      setValue: setValue,
      register,
      control,
      OPTION_GROUP,
      optionDateLocale,
      onChangeHandle,
      disableForm,
      watch,
    });
  };

  // START TABLE DSCTSSDUNG
  const {
    fields: fieldsDSCTSSDUNG,
    append: appendDSCTSSDUNG,
    remove: removeDSCTSSDUNG,
    replace: replaceDSCTSSDUNG,
  } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: TAX_DEDUCT_DSCTSSDUNG_FIELD.DSCTSSDUNG_LIST.field, // unique name for your Field Array
    keyName: "key", // keyName: "id", default to "id", you can change the key name
  });

  const defaultValueLineDSCTSSDUNG = {
    [TAX_DEDUCT_DSCTSSDUNG_FIELD.DSCTSSDUNG_LIST.TTCHUC.field]: "",
    [TAX_DEDUCT_DSCTSSDUNG_FIELD.DSCTSSDUNG_LIST.SERI.field]: "",
    [TAX_DEDUCT_DSCTSSDUNG_FIELD.DSCTSSDUNG_LIST.TNGAY.field]: [],
  };

  const addNewLineDSCTSSDUNG = () => {
    appendDSCTSSDUNG(defaultValueLineDSCTSSDUNG);
  };
  // END TABLE DSCTSSDUNG

  // START TABLE DSDKUNHIEM
  const {
    fields: fieldsDSDKUNHIEM,
    append: appendDSDKUNHIEM,
    remove: removeDSDKUNHIEM,
  } = useFieldArray({
    control,
    name: TAX_DEDUCT_DSDKUNHIEM_FIELD.DSDKUNHIEM_LIST.field,
    keyName: "key",
  });

  const defaultValueLineDSDKUNHIEM = {
    [TAX_DEDUCT_DSDKUNHIEM_FIELD.DSDKUNHIEM_LIST.LDKUNhiem.field]: null,
    [TAX_DEDUCT_DSDKUNHIEM_FIELD.DSDKUNHIEM_LIST.TLCTU.field]: "",
    [TAX_DEDUCT_DSDKUNHIEM_FIELD.DSDKUNHIEM_LIST.KHMCTU.field]: KHMCTU_DEFAULT,
    [TAX_DEDUCT_DSDKUNHIEM_FIELD.DSDKUNHIEM_LIST.KHCTU.field]: "",
    [TAX_DEDUCT_DSDKUNHIEM_FIELD.DSDKUNHIEM_LIST.MST.field]: "",
    [TAX_DEDUCT_DSDKUNHIEM_FIELD.DSDKUNHIEM_LIST.TTCHUC.field]: "",
    [TAX_DEDUCT_DSDKUNHIEM_FIELD.DSDKUNHIEM_LIST.MDICH.field]: "",
    [TAX_DEDUCT_DSDKUNHIEM_FIELD.DSDKUNHIEM_LIST.TNGAY.field]: [],
    [TAX_DEDUCT_DSDKUNHIEM_FIELD.DSDKUNHIEM_LIST.PTHUC.field]: "",
  };

  const addNewLineDSDKUNHIEM = () => {
    appendDSDKUNHIEM(defaultValueLineDSDKUNHIEM);
  };
  // END TABLE DSDKUNHIEM

  const onChangeHandle = (data, field) => {
    switch (field) {
      case TAX_DEDUCT_COMMON_FIELD.CQTQLY.field:
        setValue(`${TAX_DEDUCT_COMMON_FIELD.MCQTQLY.field}`, data?.code, {
          shouldValidate: true,
        });
        break;
    }
  };

  useEffect(() => {
    if (detailTaxDeductsRegistry && isOpen) {
      setDefaultValue(TOTAL_FIELD);
      const { registryTaxDeductCas } = detailTaxDeductsRegistry;
      console.log(
        "🚀 ~ useEffect ~ registryTaxDeductCas:",
        registryTaxDeductCas
      );

      if (registryTaxDeductCas && registryTaxDeductCas?.length > 0) {
        const listDSCTSSDUNG = registryTaxDeductCas.map(item => {
          const tngay = new Date(item.tngay);
          const dngay = new Date(item.dngay);
          return {
            ttchuc: item.ttchuc,
            seri: item.seri,
            tngay: [tngay, dngay],
            hthuc: OPTION_CA_HTHUC.find(
              option => Number(option.value) === Number(item.hthuc)
            ),
          };
        });
        console.log("🚀 ~ useEffect ~ listDSCTSSDUNG:", listDSCTSSDUNG);
        removeDSCTSSDUNG(fieldsDSCTSSDUNG.map((_, index) => index));
        setTimeout(() => {
          replaceDSCTSSDUNG(listDSCTSSDUNG);
        });
      }
    }
  }, [detailTaxDeductsRegistry]);

  return (
    <Modal
      size="lg"
      contentClassName="detail-data-format"
      style={{ maxWidth: "95%" }}
      //   contentClassName="custom-modal-style"
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          {t(`modal.title.${dataDetail?.mode}`)}
        </ModalHeader>
        {loadingDetail ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="3"
              countButton="1"
              formClass="row-cols-1 row-cols-md-2"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : (
          <React.Fragment>
            <ModalBody>
              <div
                ref={modal}
                style={{
                  maxHeight: "79vh",
                  overflow: "auto",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                }}
              >
                <div className="custom-form-heading">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong> Thông tin chung</strong>
                </div>
                <Card
                  style={{
                    border: "1px solid #d4d4d4",
                    zIndex: "3",
                    marginBottom: "10px",
                  }}
                >
                  <CardBody>
                    <Row className="row-cols-2 row-cols-md-2">
                      {Object.entries(
                        customViewField([FIRST_BLOCK[0], FIRST_BLOCK[1]])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                    </Row>
                    <Row className="row-cols-2 row-cols-md-2">
                      {Object.entries(
                        customViewField([
                          FIRST_BLOCK[2],
                          FIRST_BLOCK[3],
                          FIRST_BLOCK[4],
                          FIRST_BLOCK[3],
                          FIRST_BLOCK[4],
                          FIRST_BLOCK[5],
                          FIRST_BLOCK[6],
                          FIRST_BLOCK[7],
                          FIRST_BLOCK[8],
                          FIRST_BLOCK[9],
                          FIRST_BLOCK[10],
                          FIRST_BLOCK[11],
                          FIRST_BLOCK[12],
                        ])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                    </Row>
                  </CardBody>
                </Card>
                <div className="custom-form-heading">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>Đối tượng phát hành</strong>
                </div>
                <Card
                  style={{
                    border: "1px solid #d4d4d4",
                    zIndex: "3",
                    marginBottom: "10px",
                  }}
                >
                  <CardBody>
                    <Row className="row-cols-1 row-cols-md-1">
                      {Object.entries(
                        customViewField([SECOND_BLOCK[0], SECOND_BLOCK[1]])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                    </Row>
                  </CardBody>
                </Card>
                <div className="custom-form-heading">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>Loại hình sử dụng</strong>
                </div>
                <Card
                  style={{
                    border: "1px solid #d4d4d4",
                    zIndex: "3",
                    marginBottom: "10px",
                  }}
                >
                  <CardBody>
                    <Row className="row-cols-1 row-cols-md-1">
                      {Object.entries(
                        customViewField([
                          THIRD_BLOCK[0],
                          THIRD_BLOCK[1],
                          THIRD_BLOCK[2],
                          THIRD_BLOCK[3],
                          THIRD_BLOCK[4],
                        ])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                    </Row>
                  </CardBody>
                </Card>
                <div className="custom-form-heading">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>Hình thức gửi dữ liệu</strong>
                </div>
                <Card
                  style={{
                    border: "1px solid #d4d4d4",
                    zIndex: "3",
                    marginBottom: "10px",
                  }}
                >
                  <CardBody>
                    <Row className="row-cols-1 row-cols-md-1">
                      {Object.entries(
                        customViewField([
                          FOURTH_BLOCK[0],
                          FOURTH_BLOCK[1],
                          FOURTH_BLOCK[2],
                        ])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                    </Row>
                  </CardBody>
                </Card>
                <div className="custom-form-heading">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>Danh sách chứng thư số sử dụng</strong>
                </div>
                {listSignInfo && listSignInfo.length > 0 && !disableForm && (
                  <button
                    type="button"
                    disabled={loadListMethodSign}
                    className={`mb-2 btn btn-${
                      listSignInfo.length > 0 ? "success" : "warning"
                    }`}
                    onClick={() => {
                      console.log("🚀 ~ onClick ~ listSignInfo:", listSignInfo);
                      const dsctssdungDefault = listSignInfo.map(item => {
                        return {
                          ttchuc: item.company_name
                            ? item.company_name
                            : undefined,
                          seri: item.serial_num ? item.serial_num : undefined,
                          tngay: [
                            new Date(item.issued_time),
                            new Date(item.expired_time),
                          ],
                          hthuc: undefined,
                        };
                      });
                      console.log("🚀 ~ dsctssdungDefault:", dsctssdungDefault);
                      // Remove all item in fieldsDSCTSSDUNG and add 1 item
                      removeDSCTSSDUNG(
                        fieldsDSCTSSDUNG.map((_, index) => index)
                      );
                      setTimeout(() => {
                        appendDSCTSSDUNG(dsctssdungDefault);
                      });
                    }}
                  >
                    <i
                      className={`${
                        loadListMethodSign
                          ? "bx bx-loader bx-spin"
                          : "fa fa-exclamation-circle"
                      } font-size-16 align-middle me-2`}
                    ></i>
                    {listSignInfo.length === 0
                      ? "Chưa có thông tin"
                      : "Load thông tin chứng thư số mặc định"}
                  </button>
                )}
                <Card
                  style={{
                    border: "1px solid #d4d4d4",
                    zIndex: "3",
                    marginBottom: "10px",
                  }}
                >
                  <CardBody>
                    <Row className="row-cols-1 row-cols-md-1">
                      {generateTableV2({
                        isShowButton: true,
                        fieldConstant:
                          TAX_DEDUCT_DSCTSSDUNG_FIELD.DSCTSSDUNG_LIST.field,
                        listConstant:
                          TAX_DEDUCT_DSCTSSDUNG_FIELD.DSCTSSDUNG_LIST,
                        fieldsArray: fieldsDSCTSSDUNG,
                        removeFunc: removeDSCTSSDUNG,
                        addFunc: addNewLineDSCTSSDUNG,
                        isAuto: false,
                        styleTable: {},
                        t,
                        disableForm,
                        touchedFields,
                        register,
                        errors,
                        mode: dataDetail?.mode,
                        optionDateLocale,
                        control,
                      })}
                    </Row>
                  </CardBody>
                </Card>
                {/* <div className="custom-form-heading">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>Đăng ký ủy nhiệm lập biên lai</strong>
                </div> */}
                {/* <Card
                  style={{
                    border: "1px solid #d4d4d4",
                    zIndex: "3",
                    marginBottom: "10px",
                  }}
                >
                  <CardBody>
                    <Row className="row-cols-1 row-cols-md-1">
                      {generateTableV2({
                        fieldsArrayMinLengthAllowDelete: 0,
                        isShowButton: true,
                        fieldConstant:
                          TAX_DEDUCT_DSDKUNHIEM_FIELD.DSDKUNHIEM_LIST.field,
                        listConstant:
                          TAX_DEDUCT_DSDKUNHIEM_FIELD.DSDKUNHIEM_LIST,
                        fieldsArray: fieldsDSDKUNHIEM,
                        removeFunc: removeDSDKUNHIEM,
                        addFunc: addNewLineDSDKUNHIEM,
                        isAuto: false,
                        styleTable: {},
                        t,
                        disableForm,
                        touchedFields,
                        register,
                        errors,
                        mode: dataDetail?.mode,
                        optionDateLocale,
                        control,
                      })}
                    </Row>
                  </CardBody>
                </Card> */}
              </div>
            </ModalBody>
            <ModalFooter>
              <React.Fragment>
                {(dataDetail?.mode === MODE_FORM.ADD ||
                  dataDetail?.mode === MODE_FORM.EDIT) && (
                  <Button
                    type="button"
                    color={
                      dataDetail?.mode === MODE_FORM.ADD ? "primary" : "success"
                    }
                    className="btn-label"
                    disabled={loadingCreate || loadingEdit}
                    onClick={handleSubmit(submitForm)}
                  >
                    <i className="fas fa-save label-icon"></i>
                    {t(`button.${dataDetail?.mode}`)}
                  </Button>
                )}
              </React.Fragment>
            </ModalFooter>
          </React.Fragment>
        )}
      </div>
    </Modal>
  );
};

DetailData.propTypes = {
  toggle: PropTypes.func,
  toggleReleaseModal: PropTypes.func,
  isOpen: PropTypes.bool,
  dataDetail: PropTypes.object,
  t: PropTypes.any,
  i18n: PropTypes.any,
};

export default DetailData;
